import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ADD_CREATE_QUESTION } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AddCreateQuestion, AddCreateQuestionDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadAddCreateQuestion =
  (
    id: number,
    questions: AddCreateQuestion,
  ): ThunkAction<
    Promise<void>,
    State,
    null,
    AddCreateQuestionDataActionTypes
  > =>
  async (dispatch: any) => {
    dispatch({ type: ADD_CREATE_QUESTION + REQUEST });
    try {
      const payload = await api.loadCreateQuestion(id, questions);
      dispatch({ type: ADD_CREATE_QUESTION + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ADD_CREATE_QUESTION + FAILURE, error });
    }
  };

export const createQuestionIdle = () => ({ type: ADD_CREATE_QUESTION + IDLE });
